module.exports = __webpack_public_path__ + "media/img/vca/venuewinner-0d0e084108990a5e17c626599cd03438.png";